import { Dispatch } from "redux"

import { Api } from "api"
import { ResultModel } from "types/ApiResponse"
import { PromiseAction } from "types/RemoteAction"
import { PKDOption } from "types/Template"

export const fetchPKD =
  () =>
  (dispatch: Dispatch): PromiseAction<ResultModel<PKDOption[]>> =>
    dispatch({
      type: "pkd/FETCH",
      promise: Api.getPKD()
    })
